// lights/shell.jsx — full-takeover Lighting surface.
//
// Replaces the centered ALightsModal as the entry point for "control
// this room's lights." Wraps the existing ALightsModal body verbatim
// inside TakeoverShell — same controls, more room to breathe, and
// consistent visual rhythm with MusicShell / TVShell.
//
// Room-scoped only (focusRoomId required). Opened from the Lights
// tile's whole-tile-click handler in direction-a.jsx.

import { TakeoverShell, ALightsModal } from '../direction-a.jsx';

export function LightsShell({ T, open, onClose, rooms, focusRoomId, viewport, updateLight, updateUtility }) {
  if (!open || !focusRoomId) return null;
  const room = rooms?.find((r) => r.id === focusRoomId);
  if (!room) return null;
  return (
    <TakeoverShell T={T} viewport={viewport}
      eyebrow="Lighting" title={room.name} onClose={onClose}>
      <ALightsModal T={T} room={room} updateLight={updateLight} updateUtility={updateUtility}/>
    </TakeoverShell>
  );
}
